import {
  HubConnectionBuilder,
  HttpTransportType,
  LogLevel,
} from "@microsoft/signalr";
import { $getFromCookies } from "@/utils";
import config from "../../appConfig";
import store from '@/store';
import { log as debugLog, warn as debugWarn, error as debugError } from '@/utils/debugLogger';
const signalR = {
  install(Vue) {
    if ($getFromCookies("token")) notification(Vue);
  },
};

function notification(Vue) {
  const connection = new HubConnectionBuilder()
    .withUrl(`${config.API_URL}notifications`, {
      skipNegotiation: true,
      transport: HttpTransportType.WebSockets,
      accessTokenFactory: () => $getFromCookies("token"),
    })
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Information)
    .build();
  Vue.prototype.$notifications = connection;
  async function start() {
    try {
      await Vue.prototype.$notifications.start();
      debugLog("SignalR Connected. notifications");
      connection.on("SendNotification", (notification) => {
        debugLog("notification", notification);
        if ("Notification" in window) {
          Notification.requestPermission().then(function (permission) {
            if (permission === "granted") {
              var windowNotification = new Notification("Notification", {
                body: "New notification",
                icon: "/img/brand/AVA_Logo_Mint.svg",
              });
              windowNotification.onclick = (e) => {
                debugLog("clicked", e);
              };
              setTimeout(
                windowNotification.close.bind(windowNotification),
                10000
              );
            }
          });
        }
      });


      connection.on("SendRealtimeNotification", (notification) => {
        debugLog(notification);
        switch (notification.type) {
          case 1:
            //  useJobItemStore().notified(notification);
            break;
          case 10001: {
            let parsedMainBody = JSON.parse(notification.body)
            parsedMainBody.body = JSON.parse(parsedMainBody.body)
            store.commit('NOTIFICATIONS/PUSH_USER_NOTIFICATION', parsedMainBody);
          }
            break;
          case 10002:
            handleTagImport(notification);
            break;
          case 10003:
          case 10004:
            handleApiDataPull(notification);
            break;
          default:
            break;
        }
      });
    } catch (err) {
      debugError(err);
      setTimeout(start, 5000);
    }
  }
  function handleApiDataPull(notification) {
    let parsedMainBody = JSON.parse(notification.body);
    parsedMainBody.body = JSON.parse(parsedMainBody.body);
    store.commit('NOTIFICATIONS/PUSH_USER_NOTIFICATION', parsedMainBody);
  }
  function handleTagImport(notification) {
    let parsedMainBody = JSON.parse(notification.body);
    parsedMainBody.body = JSON.parse(parsedMainBody.body)
    store.commit('NOTIFICATIONS/PUSH_USER_NOTIFICATION', parsedMainBody);
    store.dispatch('GET_MASTERS_STATUS');
  }
  Vue.prototype.$notifications.onclose(async () => {
    setTimeout(async () => {
      debugLog(
        "🚀 ~ file: signalR.js:50 ~ setTimeout ~ connection.state:",
        connection.state
      );
      await start();
    }, 5000);
  });

  // Start the connection.
  start();
}
export default signalR;
